import { render, staticRenderFns } from "./insert.vue?vue&type=template&id=da61c0ec&scoped=true&"
import script from "./insert.vue?vue&type=script&lang=js&"
export * from "./insert.vue?vue&type=script&lang=js&"
import style0 from "./insert.vue?vue&type=style&index=0&id=da61c0ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da61c0ec",
  null
  
)

export default component.exports